<template>
    <el-dialog title="修改密码" v-model="open" width="500px" append-to-body :before-close="cancel">
        <el-form ref="pwdRef" :model="user" :rules="rules" label-width="80px">
            <!-- <el-form-item label="旧密码" prop="oldPassword">
                <el-input v-model="user.oldPassword" placeholder="请输入旧密码" type="password" show-password />
            </el-form-item> -->
            <el-form-item label="新密码" prop="newPassword">
                <el-input v-model.trim="user.newPassword" placeholder="请输入新密码" type="password" show-password />
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword">
                <el-input v-model.trim="user.confirmPassword" placeholder="请确认新密码" type="password" show-password/>
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
               <el-button @click="cancel">取 消</el-button>
               <el-button type="primary" :loading="loading" @click="submit">确 定</el-button>
            </div>
         </template>
    </el-dialog>
</template>

<script setup>
import { ref, defineProps,defineEmits } from 'vue';
import { useUserStore } from '@/store/modules/user'
import { useRouter } from 'vue-router'
import { UserPasswordUpdate } from '@/api/system/user'

const props = defineProps({
  currentRow: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

const emits = defineEmits('reload');


const router = useRouter()
const userStore = useUserStore()

const open = ref(false)
const pwdRef = ref(null)
const loading = ref(false)

const user = reactive({
//   oldPassword: undefined,
  newPassword: undefined,
  confirmPassword: undefined
});

const equalToPassword = (rule, value, callback) => {
  if (user.newPassword !== value) {
    callback(new Error("两次输入的密码不一致"));
  } else {
    callback();
  }
};

const rules = ref({
//   oldPassword: [{ required: true, message: "旧密码不能为空", trigger: "blur" }],
  newPassword: [{ required: true, message: "新密码不能为空", trigger: "blur" }, { min: 6, max: 20, message: "长度在 6 到 20 位", trigger: "blur" }],
  confirmPassword: [{ required: true, message: "确认密码不能为空", trigger: "blur" }, { required: true, validator: equalToPassword, trigger: "blur" }]
});

/** 提交按钮 */
function submit() {
  pwdRef.value.validate(async (valid) => {
    if (valid) {
      loading.value = true
      let currentRowId = props.currentRow?.id
      try {
        let params = {
          tenant_id: 0,
          ct: 1,
          id: currentRowId || userStore.userInfo.user_id,
          password: user.newPassword
        }
        await UserPasswordUpdate(params)
        if (currentRowId) {
          ElMessage.success('操作成功')
          emits('reload')
          cancel()
          return
        }
        userStore.loginOut(router)
      } catch (error) {
        console.log(error)
      } finally {
        loading.value = false
      }
    }
  });
};


function cancel() {
    pwdRef.value.resetFields();
    open.value = false
    pwdRef.oldPassword = undefined
    pwdRef.newPassword = undefined
    pwdRef.confirmPassword = undefined

}

defineExpose({
  open
})
</script>